import { useSelector } from 'react-redux';
export const selectMoveableFrame = (state) => state.moveableFrame;
export const useSelectMoveableFrame = () => useSelector(selectMoveableFrame);
